import React from "react";
import { Controller, useForm } from "react-hook-form";
import EditorSearchIcon from "@atlaskit/icon/glyph/editor/search";

import Api from "../../services/Api";
import { Grid } from "../../UI/Grid";
import { Button } from "../../UI/Button";
import useAuth from "../../routes/login/AuthContext";
import { getControllerCheckboxRender } from "../../helpers/getControllerCheckboxRender";
import { getControllerTextFieldRender } from "../../helpers/getControllerTextFieldRender";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { useSnackbar } from "../../hooks/useSnackbar";

interface IProps {
  isGlobalSearch?: boolean;
  onSuccess: (data: any) => void;
}

interface IFormData {
  lastName: string;
  firstName: string;
  globalSearch?: boolean;
}

export const UserSearchByNameForm: React.FC<IProps> = (props) => {
  const { isSuperAdmin, getAuthToken } = useAuth();
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);
  const { control, handleSubmit, reset } = useForm<IFormData>({
    defaultValues: {
      firstName: "",
      lastName: "",
      globalSearch: false,
    },
  });
  const { selectedNetworkId } = useSelectedNetworkContext();

  const onSubmit = async (data: IFormData) => {
    setIsLoading(true);

    try {
      const res = await Api.getUserSearchByName(
        selectedNetworkId,
        data.firstName.trim(),
        data.lastName.trim(),
        data.globalSearch,
        await getAuthToken()
      );

      props.onSuccess(res);
    } catch (error: any) {
      showErrorSnackbar(error.message);
    }

    reset();
    setIsLoading(false);
  };

  return (
    <Grid container spacing={2} alignItems="end" component="form" onSubmit={handleSubmit(onSubmit)}>
      <Grid item>
        <Controller name="firstName" control={control} render={getControllerTextFieldRender({ label: "First Name" })} />
      </Grid>
      <Grid item>
        <Controller name="lastName" control={control} render={getControllerTextFieldRender({ label: "Last Name" })} />
      </Grid>
      <Grid item mb={0.5}>
        <Button
          type="submit"
          appearance="primary"
          isLoading={isLoading}
          iconBefore={<EditorSearchIcon label="Search" />}
        >
          Search
        </Button>
      </Grid>
      {isSuperAdmin() && props.isGlobalSearch && (
        <Grid item xs={12}>
          <Controller
            control={control}
            name="globalSearch"
            defaultValue={false}
            render={getControllerCheckboxRender({ label: "Global Search" })}
          />
        </Grid>
      )}
    </Grid>
  );
};

UserSearchByNameForm.defaultProps = {
  isGlobalSearch: true,
};
